import { useNavigate, useLocation } from 'react-router-dom'
import { useData } from '../../contexts/DataContext'
import { useView } from '../../contexts/ViewContext'

const iconMap = {
  map: '🗺️',
  grid: '⊞',
  chart: '📊',
  compare: '📈',
}

function ViewSelector() {
  const navigate = useNavigate()
  const _location = useLocation()
  const { config } = useData()
  const { activeView, availableViews, setActiveView } = useView()

  const handleViewChange = viewId => {
    setActiveView(viewId)
    // Preserve existing query parameters when changing views
    const currentParams = new URLSearchParams(_location.search)
    const newPath = `/dashboard/${viewId}${currentParams.toString() ? `?${currentParams.toString()}` : ''}`
    navigate(newPath)
  }

  if (!config?.views || !availableViews) {
    return null
  }

  // Filter views to only show available ones for current category
  const filteredViews = config.views.filter(view =>
    availableViews.includes(view.id)
  )

  if (filteredViews.length === 0) {
    return null
  }

  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm font-medium text-gray-700">View:</span>
      <div className="flex bg-gray-100 rounded-lg p-1">
        {filteredViews.map(view => (
          <button
            key={view.id}
            onClick={() => handleViewChange(view.id)}
            className={`px-3 py-1 rounded-md font-medium transition-colors text-sm flex items-center space-x-1 ${
              activeView === view.id
                ? 'bg-white text-primary-600 shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <span>{iconMap[view.icon] || '📄'}</span>
            <span>{view.name}</span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default ViewSelector
